import { Pagination } from './../models/pagination.model';
import { map, MonoTypeOperatorFunction } from 'rxjs';
import { DateAdapter } from '../adapters/date-adapter';


export function withDateAdapter<T>(fields: string[]): MonoTypeOperatorFunction<T> {
  return map(data => DateAdapter.fromAPI(data, fields));
}

export function withDateAdapterPage<T extends Pagination<any>>(fields: string[]): MonoTypeOperatorFunction<T> {
  return map(pagination => {
    return {
      ...pagination,
      rows: pagination.rows.map(item => DateAdapter.fromAPI(item, fields))
    };
  });
}
